module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "timber.75f0e7ca.svg";